import React, { FC, useEffect } from 'react';
import { styled } from 'styled-components';
import { getIsMobile } from '../../../utils/getIsMobile';
import { getTheme } from '../../../utils/getTheme';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { ReactComponent as UserCoverSvg } from '../../resources/defaultCover.svg';

interface ShadowProps {
    isVisible: boolean;
}

export const Shadow = styled(Box)
    .withConfig({ displayName: 'Shadow' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        background: 'rgba(0, 0, 0, 0.70)',
        transition: '200ms linear opacity',
        cursor: 'pointer',
    }))<ShadowProps>`
            opacity: ${({ isVisible }) => (isVisible ? 0 : 1)};
            z-index: ${({ isVisible }) => (isVisible ? 1 : 5)};
            pointer-events: ${({ isVisible }) => (isVisible ? 'none' : 'auto')};
    `;

interface PostAdCardProps {
    postIndex: number;
    adInterval: number;
    isVisible?: boolean;
    isActiveCard?: boolean;
}

const adIds = ['R-I-10074220-1', 'R-I-10074220-2', 'R-I-10074220-3'];

export const PostAdCard: FC<PostAdCardProps> = ({
    postIndex,
    adInterval,
    isVisible = false,
    isActiveCard = false,
}) => {
    // Учитывая interval рекламы, index карточки и массив рекламных блоков дает выход вида:
    // f(index) = 0,
    // f(index + interval) = 1,
    // f(index + 2 * interval) = 2,
    // ...,
    // f(index + adIds.length * interval) = adIds.length - 1,
    // f(index + (adIds.length + 1) * interval) = 0
    const adBlockIndex = Math.abs(postIndex - adInterval / adInterval) % adIds.length;
    const id = adIds[adBlockIndex];
    const isMobile = getIsMobile();

    useEffect(() => {
        // @ts-ignore
        window.yaContextCb.push(() => {
            // @ts-ignore
            Ya.Context.AdvManager.render({
                blockId: id,
                renderTo: `yandex_rtb_${id}_${postIndex}`,
                darkTheme: getTheme() === 'dark',
                allowRepeatAds: { screen: 50, custom: true, maxSkipSize: 50 },
            });
        });
    }, [id]);

    return (
        <Flex
            width="100%"
            height={isMobile ? '100%' : undefined}
            alignItems="center"
            justifyContent="center"
            scrollSnapAlign="center"
            position="relative"
            scrollSnapStop="always"
        >
            {isMobile && (
                <Box position="absolute" top="0" left="0" width="100%" height="100%" zIndex={-1}>
                    <UserCoverSvg width="100%" height="100%" />
                </Box>
            )}
            <Box id={`yandex_rtb_${id}_${postIndex}`} width="100%" />
            {isMobile && <Shadow isVisible={isVisible || isActiveCard} />}
        </Flex>
    );
};
